
import React from "react";
import { Button, Intent } from "@blueprintjs/core";
import { isEmpty } from "lodash";
import { base } from "./../../../../fire";

import Participant from "../../../../services/Participant";

import SequenceInterlude from './SequenceInterlude'

import ResourceViewer from "../ResourceViewer";
import SequencePagination from "../SequencePagination";
import PairComparisonVote from "../Vote/PairComparison";
import MultipleScaleVote from "../Vote/MultipleScale";
import MultipleChannelVote from "../Vote/MultipleChannel";
import ManualChoiceVote from "../Vote/ManualChoice"

import AutonomousContainer from "components/Player/layout/AutonomousContainer"
import ControlContainer from "components/Player/layout/ControlContainer"
import { translate } from "utlis/translations/i18n";
import switchView from 'assets/switchView.png';

class PlayerSequence extends React.Component {
  handleVote = (value = null) => {
    const { session, instance } = this.props;
    const { currentSequence } = instance;
    const { data } = session;
    const { sequences } = data;
    const sequenceId = sequences[currentSequence].id;

    base.post(
      `sessionInstances/${session.id}/${instance.id
      }/results/${sequenceId}/${Participant.getParticipantIdBySessionId(
        session.id
      )}`,
      { data: value }
    );
  };

  render() {
    const {
      session,
      current,
      sequences = [],
      instance,
      onSwitchResource,
      onNextSequence,
      onPrevSequence,
      onFinishSequence,
      onBackSequence,
      onPrevInterlude,
      onNextInterlude,
      onFinishInterlude
    } = this.props;
    const { metadata } = session;
    const { type } = metadata;

    if (current >= sequences.length || current < 0)
      return (
        <p>Oops, sequences won't be displayed. (OUT_OF_LENGTH)</p>
      );
    if (type === "PILOTED")
      return (
        <PilotedLayout
          session={session}
          sequences={sequences}
          instance={instance}
          onVote={this.handleVote}
        />
      );
    if (type === "AUTONOMOUS")
      return (
        <AutonomousLayout
          session={session}
          sequences={sequences}
          instance={instance}
          onVote={this.handleVote}
          onSwitchResource={onSwitchResource}
          onNextSequence={onNextSequence}
          onPrevSequence={onPrevSequence}
          onFinishSequence={onFinishSequence}
          onBackSequence={onBackSequence}
          onPrevInterlude={onPrevInterlude}
          onNextInterlude={onNextInterlude}
          onFinishInterlude={onFinishInterlude}
        />
      );
    return <div>Unknown session type</div>;
  }
}

class AutonomousLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: 'double', 
    };
    this.switchViewMode = this.switchViewMode.bind(this);
    this.updateViewMode = this.updateViewMode.bind(this);
  }
  isFirstSequence = () => this.props.instance.currentSequence === 0;
  isLastSequence = () =>
    this.props.instance.currentSequence ===
    this.props.session.data.sequences.length - 1;
  
    switchViewMode() {
      this.setState(prevState => ({
        viewMode: prevState.viewMode === 'single' ? 'double' : 'single',
      }));
    }

    updateViewMode() {
      if (window.innerWidth < 1024) { 
        this.setState({ viewMode: 'single' });
      } else {
        this.setState({ viewMode: 'double' });
      }
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateViewMode);
      this.updateViewMode();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateViewMode);
    }
  render() {
    const {
      session,
      sequences = [],
      instance,
      onVote,
      onSwitchResource,
      onNextSequence,
      onPrevSequence,
      onFinishSequence,
      onPrevInterlude,
      onNextInterlude,
      onFinishInterlude
    } = this.props;
    const { metadata, data} = session;
    const { protocol } = metadata;
    const { currentSequence } = instance;
    const votedFor = Participant.getVoteForSequence(
      instance.results,
      sequences[currentSequence].id,
      Participant.getParticipantIdBySessionId(session.id)
    );

    if (sequences[instance.currentSequence].intro
      && sequences[instance.currentSequence].intro.length > 0
      && instance.currentSequenceInterludeStep === instance.currentSequence) {
      return (
        <SequenceInterlude
          session={session}
          instance={instance}
          interludes={sequences[instance.currentSequence].intro}
          onPrevInterlude={onPrevInterlude}
          onNextInterlude={onNextInterlude}
          onFinishInterlude={onFinishInterlude}
        />
      )
    }

    return (
      <AutonomousContainer 
        protocol={protocol} 
      >
          <ResourceViewer
            sessionInstance={instance}
            session={session}
            onSwitchResource={onSwitchResource}
            viewMode={this.state.viewMode} 
          />
      <ControlContainer 
        customStyle={
          protocol === "PC" && this.state.viewMode === "double"
          ? 'sequence-control-wrapper-pc-double'
          : protocol === "PC" && this.state.viewMode === "single"
          ? 'sequence-control-wrapper-pc-single'
          : 'sequence-control-wrapper'
        }
        protocol={protocol}               
        viewMode={this.state.viewMode} 
>
            {protocol === "PC" && (
              <PairComparisonVote
                session={session}
                sequences={sequences}
                instance={instance}
                onVote={onVote}
                votedFor={votedFor}
                switchViewMode={this.switchViewMode}
                viewMode={this.state.viewMode} 
              />
            )}
            {protocol === "MS" && (
              <MultipleScaleVote
                session={session}
                sequences={sequences}
                instance={instance}
                onVote={onVote}
                votedFor={votedFor}
                className="large-hoz-padding"
              />
            )}
            {protocol === "MC" && (
              <MultipleChannelVote
                session={session}
                sequences={sequences}
                instance={instance}
                votedFor={votedFor}
                onVote={onVote}
                className="tiny-hoz-margin"
              />
            )}
              {protocol === "CM" && (
                <ManualChoiceVote
                  generalContext={metadata.context}
                  currentContext={data.sequences[currentSequence].sequenceContext}
                  session={session}
                  sequences={sequences}
                  instance={instance}
                  votedFor={votedFor}
                  onVote={onVote}
                  className="large-hoz-padding"
                  onSwitchResource={onSwitchResource}
                />
              )}

              <div className={protocol === "PC" && this.state.viewMode === "double" ? 'navigationContainerPC-double' : 'navigationContainer'}>
                <div>
                  {!this.isFirstSequence() && (
                    <Button
                      className="large-hoz-padding"
                      icon="chevron-left"
                      intent={Intent.PRIMARY}
                      disabled={this.isFirstSequence()}
                      onClick={onPrevSequence}
                      viewMode={this.state.viewMode}
                    />
                  )}
                </div>
                <div>
                  <SequencePagination
                    session={session}
                    sessionInstance={instance}
                    protocol={protocol}
                  />
                </div>
                <div>
                  {this.isLastSequence() && (
                    <Button
                      text={translate('finish')}
                      rightIcon="tick"
                      intent={Intent.SUCCESS}
                      disabled={!this.isLastSequence() || isEmpty(votedFor)}
                      onClick={onFinishSequence}
                    />
                  )}
                  {!this.isLastSequence() && (
                    <Button
                      className="large-hoz-padding"
                      rightIcon="chevron-right"
                      intent={Intent.PRIMARY}
                      disabled={this.isLastSequence() || isEmpty(votedFor)}
                      onClick={onNextSequence}
                    />
                  )}
                </div>
              </div>
              {protocol === "PC" && this.state.viewMode === "single" && (
                <div className='switchButton-container-single'>
                  <div className='switchButton' onClick={this.switchViewMode}>
                    <img src={switchView} alt="switchView" className='switchViewIcon' />
                    <p className='switchViewTxt'>Pair/Single</p>
                  </div>
                </div>
              )}


        </ControlContainer>
      </AutonomousContainer >
    );
  }
}

class PilotedLayout extends React.Component {
  render() {
    const { session, sequences, instance, onVote } = this.props;
    const { metadata } = session;
    const { protocol } = metadata;
    const { currentSequence } = instance;
    const votedFor = Participant.getVoteForSequence(
      instance.results,
      sequences[currentSequence].id,
      Participant.getParticipantIdBySessionId(session.id)
    );

    return (
      <div className="col-xs-12 col-md-4 col-md-offset-4">
        {protocol === "PC" && (
          <PairComparisonVote
            session={session}
            sequences={sequences}
            instance={instance}
            onVote={onVote}
            votedFor={votedFor}
          />
        )}
        {protocol === "MS" && (
          <MultipleScaleVote
            session={session}
            sequences={sequences}
            instance={instance}
            onVote={onVote}
            votedFor={votedFor}
          />
        )}
        {protocol === "MC" && (
          <MultipleChannelVote
            session={session}
            sequences={sequences}
            instance={instance}
            onVote={onVote}
          />
        )}

        <SequencePagination session={session} sessionInstance={instance} className='sequences-pagination-piloted' />
      </div>
    );
  }
}

export default PlayerSequence;